/* eslint-disable no-param-reassign */
import {
  State, initialState,
} from '../menu-list.slice';

export default function reset(): State {
  return initialState;
}
